// React
import React from 'react'
import PropTypes from 'prop-types'

// Appt
import Box from '../../simple/box/Box.js'
import Text from '../../simple/text/Text.js'

// Font Awesome
import FontAwesome from '../fontAwesome/FontAwesome.js'

import styled from 'styled-components'


/**
 * `Small` renders a Card to display a counter of items eg. number of posts
 */


const StyledBox = styled(Box)`
border: 2px solid #ff8300;
&:hover {
    border: 2px solid #ff8300;
}
`

const StyledText = styled(Text)`
text-decoration: none;

.action-box-small:hover &, &:focus, &:hover, &:visited, &:link, &:active, &:is(:hover) {
    text-decoration: none;
    color: #ff8300 !important;
}

&:hover:not(:first-child) {
    // background: #c34a36;
}
`

class Small extends React.Component {

  render () {

    return (
        <StyledBox
            background='primary'
            margin="xsmall"
            pad="small"
            round="small"
            style={{ width: (this.props?.width || '240px') }}
            animation='fadeIn'
            hoverIndicator={{
                color: 'besmartBlue', cursor: 'pointer'
            }}
            className="action-box-small"
            onClick={() => this.props?.onClick() }>
            <Box style={{ width: (this.props?.width || '240px') }}>
                <StyledText size="large" weight="bold" textStyle={{ underline: 'none' }} textAlign="center" color='besmartBlue' width={this.props?.width || '240px'}>
                    {this.props?.icon && <FontAwesome icon={[this.props?.iconWeight || 'fal', this.props?.icon || 'plus-circle']} />}&nbsp;
                    {this.props?.title}
                </StyledText>
            </Box>
        </StyledBox>

        )
  }
}


Small.propTypes = {
  /**
   * The title for the card
   */
  title: PropTypes.string,
  /**
   * The title for the card
   */
  onClick: PropTypes.func,
  /**
   * The icon displayed on the card
   */
  icon: PropTypes.string,
  /**
   * The FontAwesome weight for the icon
   */
  iconWeight: PropTypes.string,
}


export default Small
